/** stripped-down version of the relations object from API */
export const LeadRelationsByPlatformType = {
    instagram: {
        METRICS_TABLE: 'instagram_engagement_metrics',
        METRICS_SOCIAL_ID_FIELD: 'user_id',
        METRICS_AVG_ENGAGEMENTS_FIELD: 'avg_engagements_per_post',

        METADATA_TABLE: 'instagram_lead_metadata',
        METADATA_TYPE: 'InstagramLeadMetadata',
        METADATA_SOCIAL_ID_FIELD: 'user_id',
        METADATA_SOCIAL_UN_FIELD: 'username'
    },
    youtube: {
        METRICS_TABLE: 'youtube_engagement_metrics',
        METRICS_SOCIAL_ID_FIELD: 'youtube_channel_id',
        METRICS_AVG_ENGAGEMENTS_FIELD: 'avg_engagements_per_post',

        METADATA_TABLE: 'youtube_lead_metadata',
        METADATA_TYPE: 'YoutubeLeadMetadata',
        METADATA_SOCIAL_ID_FIELD: 'youtube_channel_id',
        METADATA_SOCIAL_UN_FIELD: 'youtube_channel_name'
    },
    twitter: {
        METRICS_TABLE: 'twitter_engagement_metrics',
        METRICS_SOCIAL_ID_FIELD: 'twitter_id',
        METRICS_AVG_ENGAGEMENTS_FIELD: 'avg_engagements_per_post',

        METADATA_TABLE: 'twitter_lead_metadata',
        METADATA_TYPE: 'TwitterLeadMetadata',
        METADATA_SOCIAL_ID_FIELD: 'twitter_id',
        METADATA_SOCIAL_UN_FIELD: 'twitter_handle'
    },
    snapchat: {
        METRICS_TABLE: 'snapchat_engagement_metrics',
        METRICS_SOCIAL_ID_FIELD: 'snapchat_handle',
        METRICS_AVG_ENGAGEMENTS_FIELD: 'avg_engagements_per_post',

        METADATA_TABLE: 'snapchat_lead_metadata',
        METADATA_TYPE: 'SnapchatLeadMetadata',
        METADATA_SOCIAL_ID_FIELD: 'snapchat_handle',
        METADATA_SOCIAL_UN_FIELD: 'snapchat_handle'
    },
    tiktok: {
        METRICS_TABLE: 'instagram_engagement_metrics',
        METRICS_SOCIAL_ID_FIELD: 'user_id',
        METRICS_AVG_ENGAGEMENTS_FIELD: 'avg_engagements_per_post',

        METADATA_TABLE: 'instagram_lead_metadata',
        METADATA_TYPE: 'InstagramLeadMetadata',
        METADATA_SOCIAL_ID_FIELD: 'user_id',
        METADATA_SOCIAL_UN_FIELD: 'username'
    },
};



// WEBPACK FOOTER //
// ./common/lead_metadata_helper.js